// Which backend this build talks to.
//
// Every call used to hardcode https://server.nepeto.com, and the integration deploy carried a
// commit that rewrote all 83 of them to server-integ. That made `integration` permanently
// unmergeable into `main` -- merging it would have pointed production at the integration backend --
// so every frontend release needed cherry-picks instead of a merge, with a real chance of the
// wrong commit riding along.
//
// The host is a build-time variable now. Default is production, so a build with no env set behaves
// exactly as before; the integration deploy sets REACT_APP_API_BASE=https://server-integ.nepeto.com
// in Vercel. The branches stop differing on it, and `integration` can merge to `main` freely.
export const API_BASE = process.env.REACT_APP_API_BASE || "https://server.nepeto.com";
